/** @file Tiny DOM construction helpers (safe — no innerHTML). */

/**
 * @param {string} tag
 * @param {Record<string, string | number | boolean | null | undefined> | null} attrs
 * @param {Array<Node | string | null | undefined>} children
 * @returns {HTMLElement}
 */
export function h(tag, attrs, children = []) {
  const el = document.createElement(tag);
  if (attrs) {
    for (const [k, v] of Object.entries(attrs)) {
      if (v === null || v === undefined || v === false) {
        continue;
      }
      if (k === "class" || k === "className") {
        el.className = String(v);
      } else if (k.startsWith("data-") || k.startsWith("aria-") || k === "role") {
        el.setAttribute(k, String(v));
      } else if (k === "for") {
        el.setAttribute("for", String(v));
      } else {
        // @ts-expect-error — dynamic DOM property assignment
        el[k] = v;
      }
    }
  }
  for (const child of children) {
    if (child === null || child === undefined) {
      continue;
    }
    el.appendChild(typeof child === "string" ? document.createTextNode(child) : child);
  }
  return el;
}

/**
 * @param {HTMLElement} el
 */
export function clear(el) {
  while (el.firstChild) {
    el.removeChild(el.firstChild);
  }
}
